import { cn } from '../../../lib/utils';
import type { DatePickerShortcut } from './types';
import { isShortcutDisabled } from './utils';

interface ShortcutsProps {
  shortcuts: DatePickerShortcut[];
  isMobile: boolean;
  minDate?: Date;
  maxDate?: Date;
  onSelect: (shortcut: DatePickerShortcut) => void;
}

export function Shortcuts({ shortcuts, isMobile, minDate, maxDate, onSelect }: ShortcutsProps) {
  if (isMobile) {
    return (
      <div className="flex gap-2 overflow-x-auto px-4 pb-2 pt-4 scrollbar-none">
        {shortcuts.map((shortcut) => {
          const disabled = isShortcutDisabled(shortcut, minDate, maxDate);
          return (
            <button
              key={shortcut.label}
              onClick={() => onSelect(shortcut)}
              disabled={disabled}
              className={cn(
                'shrink-0 rounded-full px-3 py-1.5 text-xs font-medium transition-colors',
                disabled
                  ? 'text-neutral-300 cursor-not-allowed'
                  : 'text-primary-500 bg-primary-50 hover:bg-primary-100'
              )}
            >
              {shortcut.label}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="w-40 shrink-0 border-r border-neutral-200 p-4">
      <div className="space-y-1">
        {shortcuts.map((shortcut) => {
          const disabled = isShortcutDisabled(shortcut, minDate, maxDate);
          return (
            <button
              key={shortcut.label}
              onClick={() => onSelect(shortcut)}
              disabled={disabled}
              className={cn(
                'block w-full rounded-lg px-3 py-2 text-left text-sm transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500',
                disabled
                  ? 'text-neutral-300 cursor-not-allowed'
                  : 'text-primary-500 hover:bg-primary-50'
              )}
            >
              {shortcut.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
